import i18next from 'i18next';

import { CLIENT_PAGES } from '~constants/pages';

export const BUTTONS = [
  {
    text: i18next.t('UnavailableProducts:removeProducts'),
    redirectPath: CLIENT_PAGES.HOME.basePath
  }
];
